import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const RegistrationProcessCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="registration-process-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("registration-process-banner-image", id)
                  : handleImageChange("registration-process-banner-image", "")
              }
              selectedFileId={
                formData?.["registration-process-banner-image"] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="registration-process-banner-heading"
            fieldName="registration-process-banner-heading"
            placeholderText="Banner Heading"
            inputValue={formData?.["registration-process-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="registration-process-banner-description"
            fieldName="registration-process-banner-description"
            placeholderText="Banner Description"
            inputValue={
              formData?.["registration-process-banner-description"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* DOCS Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Documents Heading"
            fieldId="registration-process-docs-heading"
            fieldName="registration-process-docs-heading"
            placeholderText="Documents Heading"
            inputValue={formData?.["registration-process-docs-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* DOCS Content */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Documents Content"
            fieldId="registration-process-docs-content"
            fieldName="registration-process-docs-content"
            placeholderText="Documents Content"
            inputValue={formData?.["registration-process-docs-content"] || ""}
            onChangeTextEditorFiled={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Process Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Registration Process Heading"
            fieldId="registration-process-registration-process-heading"
            fieldName="registration-process-registration-process-heading"
            placeholderText="Registration Process Heading"
            inputValue={
              formData?.["registration-process-registration-process-heading"] ||
              ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Process Content */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Registration Process Content"
            fieldId="registration-process-registration-process-content"
            fieldName="registration-process-registration-process-content"
            placeholderText="Registration Process Content"
            inputValue={
              formData?.["registration-process-registration-process-content"] ||
              ""
            }
            onChangeTextEditorFiled={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default RegistrationProcessCMSForm;
